export default __webpack_public_path__ + "static/Feedback-fa0b3da786cfb93507fa901356e5558e.mp4";